<template>
  <div class="row mb-10">
    <div
      class="col-md-6 mb-4"
      v-for="(subcat, subcatName) in firstLevelSubcategories"
      :key="subcatName"
      :data-export-category="categoryId"
      data-export-type="firstlevel-radar"
      :data-export-subcat="subcatName"
    >
      <RadarChart
        :surveyReport="categoryReport"
        :selectedCategory="categoryId"
        :selectedPopulation="selectedPopulation"
        :subCategoryPath="[subcatName]"
        :subCategoryName="subcatName"
        :hideTable="true"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import RadarChart from './charts/RadarChart.vue'

const props = defineProps({
  categoryId: { type: [String, Number], required: true },
  categoryReport: { type: Object, required: true },
  selectedPopulation: { type: String, required: true }
})

const firstLevelSubcategories = computed(() => {
  // Prend d'abord la population globale si dispo
  if (props.categoryReport.all_populations?.types?.[props.categoryId]?.sub_categories) {
    return props.categoryReport.all_populations.types[props.categoryId].sub_categories
  }
  // Sinon, prend la première population trouvée
  const popKey = Object.keys(props.categoryReport).find(k => k !== 'all_populations')
  if (popKey && props.categoryReport[popKey]?.types?.[props.categoryId]?.sub_categories) {
    return props.categoryReport[popKey].types[props.categoryId].sub_categories
  }
  return {}
})

const isQvctCategory = computed(() => {
  // On tente de récupérer le nom de la catégorie depuis le report (si dispo)
  let name = ''
  if (props.categoryReport.all_populations?.types?.[props.categoryId]?.name) {
    name = props.categoryReport.all_populations.types[props.categoryId].name
  } else {
    // Cherche dans la première population
    const popKey = Object.keys(props.categoryReport).find(k => k !== 'all_populations')
    if (popKey && props.categoryReport[popKey]?.types?.[props.categoryId]?.name) {
      name = props.categoryReport[popKey].types[props.categoryId].name
    }
  }
  return name.toLowerCase().includes('qvct')
})
</script>
